module.exports = __webpack_public_path__ + "static/media/heavy-duty.7decb1ce.svg";